import React, { useEffect, useState } from 'react';
import MobilePage from '../website-mobile/MobilePage';
import DesktopPage from '../website-desktop/DesktopPage';
import { useEnquiry } from '../hooks/useEnquiry';
import EnquiryDrawer from '../components/shared/modals/EnquiryDrawer';
import EnquiryDropdown from '../components/shared/modals/EnquiryDropdown';
import FormModal from '../components/shared/modals/FormModal';
import SchoolAiPage from '../components/SchoolAiPage';
import ZohoIQWidget from '../utils/ZohoIQWidget';
import { useLocation } from 'react-router-dom';
import { Blog_URL, routesLinks } from '../utils/RouteConstants';
import { VoiceAgentProvider } from './VoiceAgentPage/context/VoiceAgentContext';
import LandingPagev1 from '../pages/LandingPagev1';

const MOBILE_MQ = '(max-width: 768px)';

/**
 * Desktop: existing LandingPagev1. Small viewports: pasted mobile marketing UI (src/website-mobile).
 */
export default function HomePage() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_MQ).matches
  );

  const isAndroid =
    typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);

  const location = useLocation();
  const {
    enquiryOpen,
    setEnquiryOpen,
    openSchoolForm,
    setOpenSchoolForm,
    actionButtonRef,
    avoidOverlapRef,
    dropdownDirection,
    options,
    onOptionSelect,
    handleCloseForm,
    handleEnquiry
  } = useEnquiry();

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MQ);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  useEffect(() => {
    if (location.pathname === routesLinks.demoform) {
      setOpenSchoolForm(true);
    }
  }, [location.pathname, setOpenSchoolForm]);

  return (
    <VoiceAgentProvider>
      {isMobile ? (
        <MobilePage />
      ) : (
        <DesktopPage handleBtnClick={handleEnquiry} />
        // <LandingPagev1 handleBtnClick={handleEnquiry} />
      )}

      {/* Enquiry Modal */}
      {enquiryOpen && (
        isMobile ? (
          <EnquiryDrawer
            options={options}
            setEnquiryOpen={setEnquiryOpen}
            enquiryOpen={enquiryOpen}
            onOptionSelect={onOptionSelect}
          />
        ) : (
          <EnquiryDropdown
            options={options}
            setEnquiryOpen={setEnquiryOpen}
            enquiryOpen={enquiryOpen}
            actionButtonRef={actionButtonRef}
            avoidOverlapRef={avoidOverlapRef}
            onOptionSelect={onOptionSelect}
            direction={dropdownDirection}
          />
        )
      )}

      {/* School Form Modal */}
      {openSchoolForm && (
        <FormModal isOpen={openSchoolForm} onRequestClose={handleCloseForm}>
          <SchoolAiPage
            onClose={handleCloseForm}
            otpRequired={location.pathname !== routesLinks.homev2}
          />
        </FormModal>
      )}

      <ZohoIQWidget />
    </VoiceAgentProvider>
  );
}
